import { observer } from "mobx-react-lite";
import { ActionIcon, Menu, Select } from "@mantine/core";
import { action } from "mobx";
import React, { ReactNode } from "react";
import {
  IconClock12,
  IconClock24,
  IconClockHour1,
  IconClockHour3,
  IconClockHour6,
  IconRewindBackward20,
} from "@tabler/icons-react";

interface RealtimeTimeSelectProps {
  store: any;
}

const RealtimeTimeSelect: React.FC<RealtimeTimeSelectProps> = observer(
  ({ store }) => {
    const setMinutes = action((h: number) => (store.minutes = h));

    return (
      <React.Fragment>
        <Menu shadow="md" width={200}>
          <Menu.Target>
            <ActionIcon variant="filled">
              {getIcon(store.minutes, "white")}
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Label>Select time</Menu.Label>
            {[20, 60, 180, 360, 720, 1440].map((n) => {
              const selected = store.minutes === n;
              let label = `${n / 60} Hour`;
              if (n > 60) {
                label += "s";
              } else if (n === 20) {
                label = "20 Minutes";
              }
              return (
                <Menu.Item
                  onClick={() => setMinutes(n)}
                  leftSection={getIcon(n, selected ? "#BD6DFF" : "#B6B6B6")}
                  color={selected ? "#BD6DFF" : undefined}
                >
                  {label}
                </Menu.Item>
              );
            })}
          </Menu.Dropdown>
        </Menu>
      </React.Fragment>
    );
  },
);

function getIcon(minutes: number, color: string): ReactNode {
  const options = {
    stroke: 1.5,
    color: color,
  };
  // TODO(Adjust)
  switch (minutes) {
    case 1 * 60:
      return <IconClockHour1 {...options} />;
    case 3 * 60:
      return <IconClockHour3 {...options} />;
    case 6 * 60:
      return <IconClockHour6 {...options} />;
    case 12 * 60:
      return <IconClock12 {...options} />;
    case 20:
      return <IconRewindBackward20 {...options} />;
    default:
      return <IconClock24 {...options} />;
  }
}

export default RealtimeTimeSelect;
